import type { DocumentCountsModel } from './document-counts.model';

export type DocumentCategory = 'planograms' | 'catalogs';

export interface DocumentCategoryTagModel {
  slug: string;
  label: string;
}

export const PLANOGRAM_TAGS: DocumentCategoryTagModel[] = [
  { slug: 'planogramme-e-va', label: 'Planogramme e-va' },
  { slug: 'planogramme-shop-optimierung', label: 'Planogramme Shop-Optimierung' },
];

export function isDocumentCategory(value: string | undefined): value is DocumentCategory {
  return value === 'planograms' || value === 'catalogs';
}

export function isTagSlugOfCategory(slug: string, category: DocumentCategory): boolean {
  const isPlanogram: boolean = PLANOGRAM_TAGS.some((tag: DocumentCategoryTagModel) => tag.slug === slug);

  return isPlanogram === (category === 'planograms');
}

export function hasDocumentsOfCategory(counts: DocumentCountsModel, category: DocumentCategory): boolean {
  if (category === 'catalogs' && counts.noLabel > 0) {
    return true;
  }

  return Object.entries(counts.labels).some(([label, count]: [string, number]) => {
    // Fragile: Promi counts the documents per tag label and the labels can be renamed in the CMS.
    // Once Promi counts per slug, this becomes `tag.slug === label`.
    const isPlanogram: boolean = PLANOGRAM_TAGS.some((tag: DocumentCategoryTagModel) => tag.label === label);

    return count > 0 && isPlanogram === (category === 'planograms');
  });
}
